export default __webpack_public_path__ + "static/media/launchpad-icon.405d30ae.svg";